/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_ReplyInputs */

const en_contact_channel_reply = /** @type {(inputs: Contact_Channel_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typical reply`)
};

const lv_contact_channel_reply = /** @type {(inputs: Contact_Channel_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parasti atbildam`)
};

/**
* | output |
* | --- |
* | "Typical reply" |
*
* @param {Contact_Channel_ReplyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_reply = /** @type {((inputs?: Contact_Channel_ReplyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_ReplyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_reply(inputs)
	return en_contact_channel_reply(inputs)
});